// The official Yoga Sutras: Presence Revealed listing. Use only this link for Apple App Store buttons.
export const APP_STORE_URL = "https://apps.apple.com/us/app/id6810290564";
